module.exports = __webpack_public_path__ + "img/pasteis-img.bac97fa2.webp";